import jwt from "../../http/requests/auth/jwt/index.js";
import router from "@/router";

export default {
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.login(
        payload.userDetails.UserName,
        payload.userDetails.password
      )
        .then(response => {
          
          // if (!response.data || !response.data.data) {
          //   reject({ message: "Invalid login response." });
          //   return;
          // }

          //const result = response.data.data;
          const result = response.data.data || response.data.Data;

          if (!result) {
            reject({ message: "Invalid login response." });
            return;
          }

          //const userType = result.userData?.userType || result.userData?.UserType || result.UserData?.UserType;

          var userType = null;

          if (result.userData && result.userData.userType) {
            userType = result.userData.userType;
          } else if (result.userData && result.userData.UserType) {
            userType = result.userData.UserType;
          } else if (result.UserData && result.UserData.UserType) {
            userType = result.UserData.UserType;
          }
          if (!["SuperAdmin", "Admin", "Operator", "Regulator"].includes(userType)) {
            reject({ message: "This account is not allowed to access dashboard." });
            return;
          }

          var accessToken = result.AccessToken || result.accessToken;
          var refreshToken = result.RefreshToken || result.refreshToken;
          //var expiresAt = result.expiresAt || result.expiresIn;
          var expiresAt = result.ExpiresAt || result.expiresAt || result.ExpiresIn || result.expiresIn;
          var userData = result.UserData || result.userData;
          
          
          localStorage.setItem("token", accessToken);
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("expiresIn", expiresAt);
          localStorage.setItem("screenRolesPermissions", JSON.stringify(result.screenRolesPermissions || []));

          commit("UPDATE_USER_INFO", userData, { root: true });
          commit("SET_BEARER", accessToken);
          
          // resolve(response.data);
          resolve(result);
        })
        .catch(error => reject(error));
    });
  },

  fetchAccessToken({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      jwt.refreshToken()
        .then(response => {
          if (!response.data || !response.data.data) {
            reject(response);
            return;
          }

          const result = response.data.data;

          var accessToken = result.AccessToken || result.accessToken;
          var refreshToken = result.RefreshToken || result.refreshToken;
          var expiresAt = result.expiresAt || result.expiresIn;
          
          localStorage.setItem("token", accessToken);
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("expiresIn", expiresAt);

          commit("SET_BEARER", accessToken);
          resolve(accessToken);
        })
        .catch(error => {
          dispatch("logout");
          reject(error);
        });
    });
  },

  logout({ commit }) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expiresIn");
    localStorage.removeItem("screenRolesPermissions");

    commit("REMOVE_USER_STORE", null, { root: true });
    commit("CLEAR_USER_INFO", null, { root: true });
    commit("REMOVE_BEARER");

    if (router.currentRoute.path !== "/pages/login") {
      router.replace("/pages/login").catch(function () { });
    }
  }
};
